import ImageTextComposer from '@intercom/embercom-composer/components/image-text-composer';
export default ImageTextComposer;
